import { useAtom } from "jotai";
import {
  FeeAtom,
  FeeIncreaseAtom,
  FeeNewAtom,
  MembersAtom,
  MembersIncreaseAtom,
  MembersNewAtom
} from "./atoms";
import { SidebarSlider } from "./sidebarSlider";
import {
  formatDecimal,
  formatMoney,
  formatPercent,
  formatSignedDecimal
} from "./formatters";
import * as React from "react";
import * as strings from "./strings";
const {
  sidebar_fee_label,
  sidebar_feeincrease_label,
  sidebar_increasecount_label,
  sidebar_memberfee_increasepersent_label,
  sidebar_membercount_increasepersent_label,
  sidebar_members_label,
  sidebar_totalcount_label,
  sidebar_totalfee_label
} = strings;

export function Sidebar() {
  const [members_increase, set_members_increase] = useAtom(MembersIncreaseAtom);
  const [fee_increase, set_fee_increase] = useAtom(FeeIncreaseAtom);
  const [members] = useAtom(MembersAtom);
  const [members_new] = useAtom(MembersNewAtom);
  const [fee] = useAtom(FeeAtom);
  const [fee_new] = useAtom(FeeNewAtom);

  return (
    <div className="atc-result-content__sidebar">
      <SidebarSlider
        above={{
          label: sidebar_members_label,
          value: members.toLocaleString("da-DK", {
            style: "decimal"
          })
        }}
        value={members_increase}
        setValue={set_members_increase}
        below={{
          row1: {
            label: sidebar_membercount_increasepersent_label,
            value: formatPercent(members_increase)
          },
          row2: {
            label: sidebar_increasecount_label,
            value: formatSignedDecimal(members_new - members)
          },
          row3: {
            label: sidebar_totalcount_label,
            value: formatDecimal(members_new)
          }
        }}
        min={0}
        max={0.5}
      />
      <SidebarSlider
        above={{
          label: sidebar_fee_label,
          value: formatMoney(fee)
        }}
        value={fee_increase}
        setValue={set_fee_increase}
        below={{
          row1: {
            label: sidebar_memberfee_increasepersent_label,
            value: formatPercent(fee_increase)
          },
          row2: {
            label: sidebar_feeincrease_label,
            value: formatSignedDecimal(fee_new - fee)
          },
          row3: {
            label: sidebar_totalfee_label,
            value: formatDecimal(fee_new)
          }
        }}
        min={0}
        max={0.4}
      />
    </div>
  );
}
